import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import {
  CheckMark, DocumentUploaded, UploadNavbar,
} from './UploadBrokerDocuments.styles';
import { LogoBrokerDocuments } from '../components/Navbar.styles';
import logoGreen from '../assets/images/logo-white.svg';
import checkMark from '../assets/images/check-mark.png';
import { generalAlertSuccessToast } from '../common/utils/alerts';
import Footer from '../components/Footer';
import { getPaidQuotationDocuments } from '../features/paidQuotes/paidQuotesActions';
import PageLoading from '../common/components/elements/PageLoading';
import { Uploader } from '../common/components/uploader/Uploader';
import { uploadPaidQuoteDocument } from '../services/axios-client/axeCommons';

function PaidQuotationDocuments() {
  const { loading, documents, quoteId } = useSelector((store) => store.paidQuotes.documents);
  const { requestToken } = useParams();
  const uploaderRefs = useRef({});

  const uploadDocument = (file, documentId) => {
    let baseURL = '';
    const uploadedFile = file;
    // Make new FileReader
    const reader = new FileReader();
    // Convert the file to base64 text
    reader.readAsDataURL(uploadedFile);
    // on reader load pdf...
    reader.onload = async () => {
      const fileType = uploadedFile.type;
      baseURL = reader.result;
      const data = {
        document: baseURL.replace(`data:${fileType};base64,`, ''),
      };

      const response = await uploadPaidQuoteDocument(quoteId, documentId, data);
      if (response.status !== 200) {
        return;
      }

      getPaidQuotationDocuments(requestToken);
      const ref = uploaderRefs.current[documentId];
      if (ref?.current) {
        // e.g., reset file input inside Uploader
        ref.current.reset?.();
      }

      generalAlertSuccessToast('File caricato');
    };
  };

  const centerVariant = {
    offscreen: { scale: 0.6, opacity: 0, y: 50 },
    onscreen: {
      scale: 1,
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 2 },
    },
  };

  useEffect(() => {
    getPaidQuotationDocuments(requestToken);
  }, [requestToken]);

  if (loading) {
    <PageLoading />;
  }
  return (
    <div>
      <UploadNavbar>
        <LogoBrokerDocuments href="/">
          <motion.img
            variants={centerVariant}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.8 }}
            src={logoGreen}
            alt="Greenia SLR"
            width={150}
          />
        </LogoBrokerDocuments>
      </UploadNavbar>

      <div className="container mb-5">
        <div className="row">
          <div className="col-12">

            {documents.length === 0 && (
              <DocumentUploaded>
                <div className="custom-card shadow">
                  <CheckMark
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    <img src={checkMark} alt="Uploaded" width={150} />
                  </CheckMark>
                  <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="text-center"
                  >
                    Grazie per i documenti caricati
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.7 }}
                    className="text-center"
                  >
                    Sarai contatto a breve
                  </motion.p>
                </div>
              </DocumentUploaded>
            )}

            {documents.length > 0 && (
            <>
              <h2 className="h2 text-center fw-bold text-uppercase text-success mt-5">
                Carica i tuoi documenti
              </h2>
              <div className="d-flex gap-3 flex-wrap justify-content-center align-items-center mt-5">
                {documents.map((document) => {
                  if (!uploaderRefs.current[document.id]) {
                    uploaderRefs.current[document.id] = React.createRef();
                  }

                  return (
                    <React.Fragment key={document.id}>
                      {(document.signed_document_filename === null
              && document.is_signed_valid === null) && (
              <Uploader
                ref={uploaderRefs.current[document.id]}
                onFileUpload={(file) => uploadDocument(file, document.id)}
                note={document.document_type.name}
              />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </>
            )}

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PaidQuotationDocuments;
